/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:25 GMT
 */
const tokens = {
    core: {
        color: {
            brand: {
                value: "#2F3B4D",
                type: "color",
            },
            sea: {
                "50": {
                    value: "#F5F8F9",
                    type: "color",
                },
                "100": {
                    value: "#E4EEF6",
                    type: "color",
                },
                "200": {
                    value: "#D5E3F1",
                    type: "color",
                },
                "300": {
                    value: "#B7CCE1",
                    type: "color",
                },
                "400": {
                    value: "#8AA8C7",
                    type: "color",
                },
                "500": {
                    value: "#6381AB",
                    type: "color",
                },
                "600": {
                    value: "#455D82",
                    type: "color",
                },
                "700": {
                    value: "#364262",
                    type: "color",
                },
                "800": {
                    value: "#252C44",
                    type: "color",
                },
                "900": {
                    value: "#161B2B",
                    type: "color",
                },
            },
            legacy: {
                white: {
                    value: "#ffffff",
                    type: "color",
                },
                whiteNear: {
                    value: "#e6e6e6",
                    type: "color",
                },
                light: {
                    value: "#b3b3b3",
                    type: "color",
                },
                medium: {
                    value: "#949494",
                    type: "color",
                },
                dark: {
                    value: "#676767",
                    type: "color",
                },
                blackNear: {
                    value: "#1e1e1e",
                    type: "color",
                },
                black: {
                    value: "#000000",
                    type: "color",
                },
                sail: {
                    value: "#a5ccec",
                    type: "color",
                },
                seaGreen: {
                    value: "#c0dbd1",
                    type: "color",
                },
                jaguarRose: {
                    value: "#efb5b5",
                    type: "color",
                },
                italianSunset: {
                    value: "#f1c189",
                    type: "color",
                },
                stonewallGrey: {
                    value: "#c1c1c1",
                    type: "color",
                },
                skyDancer: {
                    value: "#3e95fa",
                    type: "color",
                },
                gramsHair: {
                    value: "#f4f6f8",
                    type: "color",
                },
                midnightExpress: {
                    value: "#202935",
                    type: "color",
                },
                bashfulBlue: {
                    value: "#6790cc",
                    type: "color",
                },
                neonFuchsia: {
                    value: "#ff4066",
                    type: "color",
                },
                jadeJewel: {
                    value: "#277d83",
                    type: "color",
                },
                saffronThread: {
                    value: "#ffb400",
                    type: "color",
                },
                antarcticBlue: {
                    value: "#2f3b4b",
                    type: "color",
                },
                galaxyEdge: {
                    value: "#3e8914",
                    type: "color",
                },
                glazedPersimmon: {
                    value: "#d64933",
                    type: "color",
                },
                stormyNight: {
                    value: "#382458",
                    type: "color",
                },
                goldenApricot: {
                    value: "#EAA14B",
                    type: "color",
                },
                mochaccino: {
                    value: "#935206",
                    type: "color",
                },
                fieryRed: {
                    value: "#E71613",
                    type: "color",
                },
                toastyRed: {
                    value: "#AF292E",
                    type: "color",
                },
                emerald: {
                    value: "#05704B",
                    type: "color",
                },
                morningMist: {
                    value: "#EBEEF2",
                    type: "color",
                },
                denim: {
                    light: {
                        value: "#CDD7E5",
                        type: "color",
                    },
                    default: {
                        value: "#385F99",
                        type: "color",
                    },
                    dark: {
                        value: "#294772",
                        type: "color",
                    },
                    darker: {
                        value: "#21395B",
                        type: "color",
                    },
                },
            },
        },
        shadow: {
            low: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "4px",
                            blur: "24px",
                            spread: "-8px",
                            color: "#00000010",
                        },
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "1px",
                            blur: "6px",
                            spread: "-2px",
                            color: "#00000038",
                        },
                    ],
                    stringValue: "0px 4px 24px -8px #00000010, 0px 1px 6px -2px #00000038",
                },
                type: "shadow",
            },
            medium: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "6px",
                            blur: "16px",
                            spread: "-4px",
                            color: "#00000020",
                        },
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "5px",
                            blur: "8px",
                            spread: "-8px",
                            color: "#00000008",
                        },
                    ],
                    stringValue: "0px 6px 16px -4px #00000020, 0px 5px 8px -8px #00000008",
                },
                type: "shadow",
            },
            high: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "10px",
                            blur: "32px",
                            spread: "-6px",
                            color: "#00000020",
                        },
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "4px",
                            blur: "4px",
                            spread: "-2px",
                            color: "#00000008",
                        },
                    ],
                    stringValue: "0px 10px 32px -6px #00000020, 0px 4px 4px -2px #00000008",
                },
                type: "shadow",
            },
        },
        spacing: {
            "1": {
                value: "8px",
                type: "dimension",
            },
            "2": {
                value: "16px",
                type: "dimension",
            },
            "3": {
                value: "24px",
                type: "dimension",
            },
            "4": {
                value: "32px",
                type: "dimension",
            },
            "5": {
                value: "40px",
                type: "dimension",
            },
            "6": {
                value: "48px",
                type: "dimension",
            },
            "7": {
                value: "56px",
                type: "dimension",
            },
            "8": {
                value: "64px",
                type: "dimension",
            },
            "0_25": {
                value: "2px",
                type: "dimension",
            },
            "0_5": {
                value: "4px",
                type: "dimension",
            },
            "1_5": {
                value: "12px",
                type: "dimension",
            },
            "2_5": {
                value: "20px",
                type: "dimension",
            },
        },
        fontFamily: {
            sourceSansPro: {
                value: "'Source Sans Pro', ui-sans-serif, system-ui, 'Helvetica Neue', Arial, sans-serif",
                type: "fontFamily",
            },
        },
        fontWeight: {
            light: {
                value: 300,
                type: "fontWeight",
            },
            regular: {
                value: 400,
                type: "fontWeight",
            },
            semibold: {
                value: 600,
                type: "fontWeight",
            },
            bold: {
                value: 700,
                type: "fontWeight",
            },
        },
        fontSize: {
            "4xl": {
                value: "4rem",
                type: "dimension",
            },
            "3xl": {
                value: "2.5rem",
                type: "dimension",
            },
            "2xl": {
                value: "1.75rem",
                type: "dimension",
            },
            xl: {
                value: "1.375rem",
                type: "dimension",
            },
            lg: {
                value: "1.125rem",
                type: "dimension",
            },
            normal: {
                value: "1rem",
                type: "dimension",
            },
            md: {
                value: "0.875rem",
                type: "dimension",
            },
            sm: {
                value: "0.8125rem",
                type: "dimension",
            },
            xs: {
                value: "0.75rem",
                type: "dimension",
            },
        },
        lineHeight: {
            "4xl": {
                value: "5rem",
                type: "dimension",
            },
            "3xl": {
                value: "3rem",
                type: "dimension",
            },
            "2xl": {
                value: "2rem",
                type: "dimension",
            },
            xl: {
                value: "1.625rem",
                type: "dimension",
            },
            lg: {
                value: "1.5rem",
                type: "dimension",
            },
            normal: {
                value: "1.25rem",
                type: "dimension",
            },
            md: {
                value: "1.125rem",
                type: "dimension",
            },
            sm: {
                value: "1rem",
                type: "dimension",
            },
            xs: {
                value: "0.875rem",
                type: "dimension",
            },
        },
        textDecoration: {
            none: {
                value: "none",
                type: "textDecoration",
            },
            underline: {
                value: "underline",
                type: "textDecoration",
            },
        },
        textTransform: {
            none: {
                value: "none",
                type: "textTransform",
            },
            uppercase: {
                value: "uppercase",
                type: "textTransform",
            },
        },
    },
};
export default tokens;
